export const isArray = (value: unknown): value is Array<unknown> =>
  Array.isArray(value);

export const isObject = (value: unknown): value is Record<string, unknown> => {
  if (value === null || typeof value !== 'object') {
    return false;
  }

  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
};

export const mapObject = <K extends string | number | symbol, T, R>(
  obj: Record<K, T>,
  fn: (value: T) => R
): Record<K, R> => {
  const result = {} as Record<K, R>;

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      result[key] = fn(obj[key]);
    }
  }

  return result;
};

export const isDeepEqual = (a: unknown, b: unknown): boolean => {
  if (a === b) {
    return true;
  }

  if (a === null || b === null || a === undefined || b === undefined) {
    return a === b;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) {
      return false;
    }
    return a.every((item, index) => isDeepEqual(item, b[index]));
  }

  if (typeof a === 'object' && typeof b === 'object') {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);

    if (keysA.length !== keysB.length) {
      return false;
    }

    return keysA.every(
      key =>
        keysB.includes(key) &&
        isDeepEqual(
          (a as { [key]: unknown })[key],
          (b as { [key]: unknown })[key]
        )
    );
  }

  return false;
};
